// store/modules/loading.js
const state = {
  loading: false,
};

const mutations = {
  SET_LOADING(state, status) {
    state.loading = status;
  },
};

const actions = {
  setLoading({ commit }, status) {
    commit('SET_LOADING', status);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
